































































































































































import { Vue, Component } from "vue-property-decorator";
import { audiobooks } from "@/config/host.config";
import { deleteElement } from "@/api/delite/delite-element";
import { AxiosError } from "axios";
import BSwitch from "@/components/app/switchs/b-switch.vue";
import AudiobookChaptersEditor from "@/components/forms/audiobooks/audiobook-chapters-editor.vue";
import MultilangInput from "@/components/forms/multilang-input.vue";
import MultilangArrayInput from "@/components/forms/multilang-array-input.vue";
import PosterEditor from "@/components/app/images/poster-editor.vue";
import StandartModal from "@/components/app/standart-modal.vue";
import LanguagesButtons from "@/components/buttons/languages-buttons.vue";
import { preferred_language } from "@/config/languags.config.json";

interface IAudiobookName {
  [key: string]: string;
  ru: string;
  en: string;
}

interface IAudiobookForm {
  name: IAudiobookName;
  description: IAudiobookName;
  shortDescription: IAudiobookName;
  vertical_poster: Record<string, string>;
  ageRating: string;
  year: number | null;
  author: Array<IAudiobookName>;
  narrator: Array<IAudiobookName>;
  publisher: string;
  languages: string[];
  category: string;
  genres: string[];
  show: boolean;
}

@Component({
  components: {
    BSwitch,
    AudiobookChaptersEditor,
    MultilangInput,
    MultilangArrayInput,
    PosterEditor,
    StandartModal,
    LanguagesButtons,
  },
})
class AudiobookDetailPage extends Vue {
  form: IAudiobookForm = {
    name: { ru: "", en: "" },
    description: { ru: "", en: "" },
    shortDescription: { ru: "", en: "" },
    vertical_poster: { ru: "", en: "" },
    ageRating: "",
    year: null,
    author: [{ ru: "", en: "" }],
    narrator: [{ ru: "", en: "" }],
    publisher: "",
    languages: [],
    category: "",
    genres: [],
    show: true,
  };
  saving = false;
  loading = false;
  genresInput = "";
  languagesInput = "";
  bookId = "";

  bookChapters: Array<{
    _id: string;
    name: Record<string, string>;
    filename: string;
    file_type: string;
    sort_order: number;
    language: string;
    duration: number;
  }> = [];
  activeLocale = preferred_language;

  get isEdit(): boolean {
    return !!this.bookId;
  }

  onPosterUpdate(filename: string): void {
    this.$set(this.form.vertical_poster, this.activeLocale, filename);
  }

  syncArrayFieldsToForm(): void {
    if (this.genresInput.trim()) {
      this.form.genres = this.genresInput
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
    }
    if (this.languagesInput.trim()) {
      this.form.languages = this.languagesInput
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
    }
  }

  closeModal(): void {
    this.$router.push({ name: "AudiobooksList" });
  }

  async save(): Promise<void> {
    this.syncArrayFieldsToForm();
    this.saving = true;
    const id = this.bookId || undefined;
    const url = id ? `${audiobooks.books}/${id}` : audiobooks.books;
    const method = id ? "put" : "post";

    try {
      const { vertical_poster, ...rest } = this.form;
      const payload = {
        ...rest,
        src: { vertical_poster, file: this.bookChapters },
      };
      const res = await this.$axios[method](url, payload);
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        if (!id && res.data?._id) {
          this.bookId = res.data._id;
          this.form = {
            name: res.data.name || { ru: "", en: "" },
            description: res.data.description || { ru: "", en: "" },
            shortDescription: res.data.shortDescription || { ru: "", en: "" },
            vertical_poster: res.data.src?.vertical_poster || {
              ru: "",
              en: "",
            },
            ageRating: res.data.ageRating || "",
            year: res.data.year || null,
            author: res.data.author?.length
              ? res.data.author
              : [{ ru: "", en: "" }],
            narrator: res.data.narrator?.length
              ? res.data.narrator
              : [{ ru: "", en: "" }],
            publisher: res.data.publisher || "",
            languages: res.data.languages || [],
            category: res.data.category || "",
            genres: res.data.genres || [],
            show: res.data.show !== false,
          };
          this.genresInput = this.form.genres.join(", ");
          this.languagesInput = this.form.languages.join(", ");
          this.bookChapters = (res.data.src && res.data.src.file) || [];
          this.$router.replace({
            name: "AudiobookDetail",
            query: { id: res.data._id },
          });
        } else {
          this.closeModal();
        }
      }
    } catch (e) {
      console.log(e);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    } finally {
      this.saving = false;
    }
  }

  async remove(): Promise<void> {
    const id = this.bookId;
    if (!id) return;

    const ok = await this.$bvModal.msgBoxConfirm(
      String(this.$t("audiobooks.confirmDeleteBook")),
      {
        title: String(this.$i18n.t("buttons.delete")),
        okVariant: "danger",
        cancelVariant: "secondary",
      }
    );
    if (!ok) return;

    deleteElement(id, audiobooks.books)
      .then(() => {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.closeModal();
      })
      .catch((e: AxiosError) => {
        console.log(e);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
      });
  }

  async fetchBook(): Promise<void> {
    const id = this.bookId;
    if (!id) return;

    this.loading = true;
    try {
      const res = await this.$axios.get(`${audiobooks.books}/${id}`);
      if (res.status === 200) {
        const book = res.data;
        this.form = {
          name: book.name || { ru: "", en: "" },
          description: book.description || { ru: "", en: "" },
          shortDescription: book.shortDescription || { ru: "", en: "" },
          vertical_poster: book.src?.vertical_poster || { ru: "", en: "" },
          ageRating: book.ageRating || "",
          year: book.year || null,
          author: book.author?.length ? book.author : [{ ru: "", en: "" }],
          narrator: book.narrator?.length
            ? book.narrator
            : [{ ru: "", en: "" }],
          publisher: book.publisher || "",
          languages: book.languages || [],
          category: book.category || "",
          genres: book.genres || [],
          show: book.show !== false,
        };
        this.genresInput = this.form.genres.join(", ");
        this.languagesInput = this.form.languages.join(", ");
        this.bookChapters = (book.src && book.src.file) || [];
      }
    } catch (e) {
      console.log(e);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    } finally {
      this.loading = false;
    }
  }

  mounted(): void {
    this.bookId = (this.$route.query.id as string) || "";
    this.fetchBook();
    this.$nextTick(() => this.$bvModal.show("audiobook-detail-modal"));
  }
}
export default AudiobookDetailPage;
